import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { DynamicHead } from "@/components/DynamicHead";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { useRealtimePresence } from "@/hooks/useRealtimePresence";

// Wrapper component to use the presence hook
const PresenceTracker = () => {
  useRealtimePresence();
  return null;
};

const Layout = () => {
  return (
    <LanguageProvider>
      <DynamicHead />
      <PresenceTracker />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default Layout;
